/* Uberflip GWL OB-7505 start here */
function languageSelector() {
    const selector = document.querySelector('#top-header .locale-selector ');
    const navBar = document.querySelector('#top-header .left-nav');

    if (selector && navBar) {
        navBar.insertAdjacentElement('afterend', selector);
    }
}
export { languageSelector };
/* Uberflip GWL OB-7505 end here */


// WEBPACK FOOTER //
// ./scriptPartials/selectorPosition.js